<template>
  <span
    v-if="count !== null && count !== undefined || showZero"
    class="text-xs font-medium transition-all duration-75 flex flex-row items-center gap-1 rounded-full px-2 py-1 whitespace-nowrap shrink-0"
    :class="type === 'gradient' ? 'bg-gradient-to-r from-[#B758F6] to-[#DE5BEC] border-transparent outline-0 border-0 disabled:bg-disabled text-inverse' : 'text-primary bg-surface-light border border-weak'"
  >
    {{ count > 0 ? count.toLocaleString() : '-' }}
    <AM3Icon
      type="user"
      size="sm"
    />
  </span>
</template>

<script setup lang="ts">
import AM3Icon from './icon/AM3Icon.vue'

withDefaults(defineProps<{
  // Number of people (subscribers, contacts, etc.) represented by this option.
  // Renders nothing when null/undefined (count not yet known); shows '-' at 0.
  count: number | null | undefined
  type?: 'default' | 'gradient'
  showZero?: boolean
}>(), {
  type: 'default',
})
</script>
